import { Localize } from '../../locales';
import { MenuConfigProps } from '../../../app/ui/components/Menu';

export type MenuConfig = Localize<MenuConfigProps>;

export const menuConfig: MenuConfig = {
	en: {},
	fr: {}
};
